import styled from 'styled-components';
import { CardExercise } from '../../../../components/CardExercise';
import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;

  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 1199px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const PageTitle = styled.h1`
  font-size: 40px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.02em;
  margin-bottom: 4px;
`;

export const TitleAccent = styled.span`
  color: ${colors.primary};
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: ${colors.onSurfaceVariant};
  max-width: 460px;
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  padding: 14px 28px;

  background-color: ${colors.primary};
  border: none;
  border-radius: ${radius.full};
  cursor: pointer;

  color: ${colors.onPrimary};
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;

  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 0 24px ${colors.primary}40;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

interface FilterPillProps {
  active: boolean;
}

export const FilterPill = styled.button<FilterPillProps>`
  padding: 10px 20px;
  border: none;
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  background-color: ${({ active }) =>
    active ? colors.primary : colors.surfaceContainerLow};
  color: ${({ active }) =>
    active ? colors.onPrimary : colors.onSurfaceVariant};

  transition: color 0.2s, background-color 0.2s;

  &:hover {
    color: ${({ active }) => (active ? colors.onPrimary : colors.onSurface)};
  }
`;

export const Content = styled.div`
  flex: 1;

  display: grid;
  grid-gap: 24px;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width: 1400px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 800px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Card = styled(CardExercise)``;
